export const planetChartData = {
  type: 'bar',
  data: {
    labels: ['Enero', 'Febrero', 'Marzo'],
    datasets: [
      { // one line graph
        label: 'Kits Diagnosticados',
        data: [318, 265, 324],
        backgroundColor: [
          'rgb(16, 64, 111)',
          'rgb(20, 79, 136)',
          'rgb(24, 93, 160)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)'
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      },
      { // one line graph
        label: 'Réplicas',
        data: [47, 64, 67],
        backgroundColor: [
          'rgb(16, 64, 111)',
          'rgb(20, 79, 136)',
          'rgb(24, 93, 160)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)'
        ],
        borderColor: [
          '#f50000',
          '#f50000',
          '#f50000',
          '#f50000',
          '#f50000',
          '#f50000',
          '#f50000',
          '#f50000',
        ],
        borderWidth: 3
      },
      { // one line graph
        label: '% replicas',
        data: [15, 24, 21],
        backgroundColor: [
          'rgb(16, 64, 111)',
          'rgb(20, 79, 136)',
          'rgb(24, 93, 160)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)'
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      }
    ]
  },
  options: {
    responsive: true,
    // maintainAspectRatio: false,
    lineTension: 1,
    scales: {
      yAxes: [{
        ticks: {
          // callback: function (value) {
          //   return value + " %";
          // },

          min: 0,
          // max: 100,
          beginAtZero: true
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        }
      }]
    }
  }
}

export default planetChartData;